function vocabularySection() {
  let vocabularyItem = $('.vocabulary-item');

  vocabularyItem.each(function () {
    $(this).on('click', function (event) {
      let modalTitle = $('#dialog-title-vocabulary');
      let modalText = $('.modal__inside-content');
      let modalNext = $('#modal-next');

      let thisTitle = $(this).data('title');
      let thisText = $(this).data('text');
      let thisKey = $(this).data('key');

      let nextKey = parseInt(thisKey) + 1;
      let next = $('.vocabulary-item-' + nextKey);
      if (!next.length) {
        // pokud jsem na konci seznamu jdi na prvni slovo
        let next = $('.vocabulary-item-0');
      }
      let nextTitle = next.data('title');
      modalTitle.html(thisTitle);
      modalText.html(thisText);
      modalNext.text(nextTitle);
      modalNext.on('click', function () {
        $('.vocabulary-item-' + nextKey).trigger('click');
      });
    });
  });

  //searching
  jQuery.expr[':'].icontains = function (a, i, m) {
    return jQuery(a).text().toUpperCase().indexOf(m[3].toUpperCase()) >= 0;
  };

  $('#vocabulary-input-search').keyup(function (event) {
    var value = $(this).val();
    if (value.length > 3) {
      $('.vocabulary-item:not(:icontains("' + value + '"))')
        .closest('.results__item')
        .hide();
      $('.vocabulary-item:not(:icontains("' + value + '"))').hide();
      var elements = $('.vocabulary-item:icontains("' + value + '")');
      elements.each(function () {
        $(this).closest('.results__item').show();
      });
      elements.show();
    } else {
      $('.vocabulary-item').closest('.results__item').show();
      $('.vocabulary-item').show();
    }
  });
}
